export const CHECKLIST_ANSWER = {
  YES: 'yes',
  PARTIAL: 'partial',
  NO: 'no',
};

export const ANSWER_SCORE = {
  [CHECKLIST_ANSWER.YES]: 1,
  [CHECKLIST_ANSWER.PARTIAL]: 0.5,
  [CHECKLIST_ANSWER.NO]: 0,
};

export const REPORT_SECTIONS = [
  {
    id: 'period',
    title: 'Период и расход',
    items: [
      { id: 'period_dates', weight: 8, title: 'Указан период отчёта', hint: 'Даты с — по', question: 'За какой точный период эти цифры?' },
      { id: 'period_spend', weight: 10, title: 'Итоговый расход на рекламу', hint: 'Совпадает с рекламным кабинетом', question: 'Покажите скрин расхода из кабинета за этот период.' },
    ],
  },
  {
    id: 'traffic',
    title: 'Охват и клики',
    items: [
      { id: 'traffic_impressions', weight: 6, title: 'Показы и клики', hint: 'Базовые метрики трафика', question: 'Сколько было показов и кликов по кампаниям?' },
      { id: 'traffic_ctr', weight: 8, title: 'CTR (доля кликов от показов)', hint: 'CTR = клики ÷ показы × 100%', question: 'Какой CTR и не просел ли он к прошлому периоду?' },
    ],
  },
  {
    id: 'leads',
    title: 'Приём и обработка заявок',
    items: [
      { id: 'leads_count', weight: 12, title: 'Количество лидов', hint: 'Заявки, звонки, сообщения — как считали', question: 'Сколько лидов и по какому источнику атрибуции?' },
      { id: 'leads_cpl', weight: 12, title: 'CPL — стоимость лида', hint: 'CPL = расход ÷ лиды', question: 'Какой CPL и что влияло на рост?' },
      { id: 'leads_trend', weight: 8, title: 'Динамика к прошлому периоду', hint: 'Стало лучше или хуже', question: 'Сравните с прошлой неделей/месяцем.' },
    ],
  },
  {
    id: 'money',
    title: 'Деньги и окупаемость',
    items: [
      { id: 'money_revenue', weight: 10, title: 'Выручка или продажи с рекламы', hint: 'Если есть CRM / 1С', question: 'Какая выручка пришла с этих лидов?' },
      { id: 'money_romi', weight: 12, title: 'ROMI — возврат на вложения', hint: 'ROMI = (выручка − расход) ÷ расход × 100%', question: 'Какой ROMI и целевой ли он?' },
    ],
  },
  {
    id: 'detail',
    title: 'Детализация',
    items: [
      { id: 'detail_campaigns', weight: 10, title: 'Разбивка по кампаниям / адсетам', hint: 'Видно, что отключить', question: 'Какие кампании тянут CPL вниз/вверх?' },
      { id: 'detail_creatives', weight: 8, title: 'Креативы и аудитории', hint: 'Что тестировали', question: 'Какие креативы лучше и что тестируем дальше?' },
    ],
  },
  {
    id: 'insights',
    title: 'Выводы и план',
    items: [
      { id: 'insights_analysis', weight: 10, title: 'Выводы: что сработало / нет', hint: 'Не только цифры', question: 'Почему CPL изменился? Ваши гипотезы?' },
      { id: 'insights_plan', weight: 10, title: 'План на следующий период', hint: 'Бюджет, тесты, изменения', question: 'Что меняем в бюджете и креативах на следующую неделю?' },
    ],
  },
];

export const getAllReportItems = () =>
  REPORT_SECTIONS.flatMap((section) => section.items.map((item) => ({ ...item, sectionId: section.id })));

export const getDefaultAnswers = () => {
  const answers = {};
  getAllReportItems().forEach((item) => {
    answers[item.id] = null;
  });
  return answers;
};

export const calculateReportScore = (answers) => {
  const items = getAllReportItems();
  let totalWeight = 0;
  let earnedWeight = 0;
  const gaps = [];
  const questions = [];

  items.forEach((item) => {
    totalWeight += item.weight;
    const answer = answers[item.id];

    if (!answer) {
      return;
    }

    earnedWeight += item.weight * (ANSWER_SCORE[answer] ?? 0);

    if (answer !== CHECKLIST_ANSWER.YES) {
      gaps.push({ ...item, answer });
      if (item.question) {
        questions.push(item.question);
      }
    }
  });

  const answeredCount = items.filter((item) => answers[item.id]).length;
  const percent =
    answeredCount > 0 && totalWeight > 0 ? Math.round((earnedWeight / totalWeight) * 100) : 0;

  return {
    percent,
    answeredCount,
    totalCount: items.length,
    isComplete: answeredCount === items.length,
    status:
      percent >= 80
        ? 'Отчёт полный — можно принимать и обсуждать оптимизацию.'
        : percent >= 50
          ? 'Есть пробелы — запросите доработку по пунктам ниже.'
          : 'Отчёт неполный — не принимайте без ключевых метрик.',
    gaps: gaps.slice(0, 5),
    questions: [...new Set(questions)].slice(0, 6),
  };
};

export const HOW_STEPS = [
  { num: '1', title: 'Каждый пункт имеет вес.', text: '«Да» = 100% балла, «Частично» = 50%, «Нет» = 0%. Итог — сумма взвешенных баллов.' },
  { num: '2', title: 'Пороги готовности:', text: 'до 50% — рано, 50–79% — доработать, 80%+ — можно запускать тест.' },
];
